package com.alpha.showcase.common.theme

import androidx.compose.ui.unit.dp

object Dimen {
    val spaceS = 4.dp
    val spaceM = 8.dp
    val spaceL = 16.dp
    val spaceXL = 32.dp
    val spaceXXL = 64.dp
    val screenContentPadding = spaceL
    val imageSizeVertical = 100.dp
    val imageSizeHorizontal = 140.dp

    val textFiledCorners = 12.dp
}
